import { render, staticRenderFns } from "./ColorLegend.vue?vue&type=template&id=4cfe9800&"
import script from "./ColorLegend.vue?vue&type=script&lang=js&"
export * from "./ColorLegend.vue?vue&type=script&lang=js&"
import style0 from "./ColorLegend.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ColorLegend.vue"
export default component.exports